/**
 * Quantas pessoas cabem numa página da lista.
 *
 * Vinte é o padrão, e cinquenta e cem estão a um clique: na semana de
 * lançamento a lista é varrida atrás de quem chegou depois do post, e de vinte
 * em vinte essa varredura virava uma sequência de idas e voltas na paginação.
 *
 * **Cem é o teto, e não é escolha desta tela**: é o `max` do Zod em
 * `GET /people`. Uma opção acima dele devolveria 422, e o efeito seria mudo - a
 * tabela presa no último resultado, sem erro de lint, de tipo nem de build,
 * porque o limite mora do outro lado da rede. Já aconteceu nesta casa três
 * vezes (ver `AcessoPage`).
 */
export const TAMANHOS_DE_PAGINA = [20, 50, 100];

export const POR_PAGINA_PADRAO = 20;

/**
 * O tamanho vem da URL, junto dos filtros e da página, porque "página 3" só
 * diz alguma coisa junto do tamanho que a define. É texto que qualquer um
 * digita na barra de endereço, então passa pela lista antes de virar consulta:
 * um `porPagina=500` viraria 422 em vez de lista.
 */
export function lerPorPagina(texto: string | undefined): number {
  const numero = Number(texto);
  return TAMANHOS_DE_PAGINA.includes(numero) ? numero : POR_PAGINA_PADRAO;
}
